module.exports = __webpack_public_path__ + "static/media/citybank.617df1f2.svg";